/**
 * Class for a dash array
 * @class
 * @param {Array | object*} dashes The dash array as per svg-specification
 */
function DashArray() {
    var args = Array.prototype.slice.call(arguments);

    if (args.length === 1 && args[0] instanceof Array) {
        args = args[0];
    }
    /** @member {Array} */
    this.dashes = args;
}
/**
 * Creates a new DashArray instance
 * @function
 * @param {Array | object*} dashes The dash array as per svg-specification
 * @return {DashArray}
 */
DashArray.new = function () {
    return new DashArray(...arguments);
};

/**
 * Copies this
 * @function
 * @return {DashArray}
 */
DashArray.prototype.copy = function () {
    return DashArray.new(this.dashes.concat());
};

/**
 * Copies this
 * @function
 * @alias DashArray.prototype.copy
 * @return {DashArray}
 */
DashArray.prototype.cp = DashArray.prototype.copy;

/**
 * Creates a string representation of this
 * @return {string}
 */
DashArray.prototype.toString = function () {
    var d = this.dashes;
    if (d.length === 0) {
        return '[]';
    }
    var s = '[';
    for (var i = 0; i < d.length - 1; i++) {
        s += d[i] + ', ';
    }

    s += d[d.length - 1];
    s += ']';
    return s;
};

DashArray.prototype.toSVG = function () {
    var d = this.dashes;
    if (d.length === 0) {
        return '';
    }
    var s = 'stroke-dasharray="';
    for (var i = 0; i < d.length - 1; i++) {
        s += d[i] + ', ';
    }

    s += d[d.length - 1];

    s += '"';
    return s;
};

DashArray.SOLID = DashArray.new();
DashArray.DASH_EVEN = DashArray.new(5, 5);
DashArray.DASH_EVEN_SPACED = DashArray.new(5, 10);
DashArray.DASH_ODD = DashArray.new(5, 5, 1, 5);


export {
    DashArray
};
